import Cookies from 'js-cookie';
import actions from './actions';
import { auth } from '../../config/firbase-config'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { DataService } from '../../config/dataService/dataService';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/users/login', values);
      console.log(response);
        if (response.data.access_token) {
          Cookies.set('access_token', response.data.access_token);
          Cookies.set('logedIn', true); 
          Cookies.set('userType', response.data.user.userType); 
          Cookies.set('userId', response.data.user._id);

          if (response.data.transaction && response.data.transaction._id) {
            Cookies.set('transactionId', response.data.transaction._id);
          } else {
            Cookies.set('transactionId', response.data.transaction);
            console.log("Transaction data or _id is missing in the response");
          }

          // Cookies.set('transactionId', response.data.transaction._id);
           
          // sessionStorage.setItem('orgId',response.data.organization_id)
          // Cookies.set('orgName',response.data.orgName)
          dispatch(loginSuccess(true));
          callback();
        }
        else{
        dispatch(loginErr(response.data.error));
        console.log(response.data.error);
      }
      setTimeout(() => {
        dispatch(loginErr('')); // Clear the error message
      }, 2000);
      // }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const register = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      createUserWithEmailAndPassword(auth, values.email, values.password)
        .then((res) => {
          console.log(res)
          Cookies.set('access_token', res.accessToken);
          Cookies.set('logedIn', true);
          dispatch(loginSuccess(true));
          callback();
        })
        .catch((err) => {
          dispatch(loginErr('Registration failed!'));
          console.log(err)
        })
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      Cookies.remove('userType');
      Cookies.remove('userId');
      Cookies.remove('transactionId');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, register };